(function () {
  'use strict';

  /* ===== Reveal on scroll ===== */
  function initReveal() {
    var reveals = document.querySelectorAll('.sr-reveal:not(.is-in)');
    if (!reveals.length) return;
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ===== Sticky CTA ===== */
  function initStickyCta() {
    var cta = document.querySelector('.sr-book-cta');
    var hero = document.querySelector('.sr-hero');
    if (!cta || !hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { cta.classList.toggle('is-visible', !e.isIntersecting); });
    }, { threshold: 0.1 }).observe(hero);
  }

  /* ===== Video play ===== */
  function initVideo() {
    var frames = document.querySelectorAll('.sr-video-frame');
    frames.forEach(function (frame) {
      if (frame.dataset.srVideoInit) return;
      frame.dataset.srVideoInit = '1';

      frame.addEventListener('click', function () {
        // Shopify-hosted video → native <video>
        if (frame.dataset.shopifyVideo === 'true') {
          var sources = frame.querySelectorAll('[data-sr-video-src]');
          if (sources.length) {
            var video = document.createElement('video');
            video.className = 'sr-video-iframe sr-video-native';
            video.autoplay = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            if (frame.dataset.videoControls === 'true') video.controls = true;
            if (frame.dataset.videoLoop === 'true') video.loop = true;
            sources.forEach(function (s) {
              var src = document.createElement('source');
              src.src = s.dataset.src;
              if (s.dataset.mime) src.type = s.dataset.mime;
              video.appendChild(src);
            });
            frame.innerHTML = '';
            frame.appendChild(video);
            var p = video.play && video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
          return;
        }

        // External embed (YouTube / Vimeo)
        var videoUrl = frame.dataset.videoUrl;
        if (videoUrl) {
          var iframe = document.createElement('iframe');
          iframe.className = 'sr-video-iframe';
          iframe.src = videoUrl + (videoUrl.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
          iframe.setAttribute('allowfullscreen', 'true');
          frame.innerHTML = '';
          frame.appendChild(iframe);
          return;
        }

        // No video source → placeholder text
        var msg = frame.dataset.videoPlaceholder || 'Imagine five minutes here — sawdust catching morning light, the kettle steaming.';
        frame.innerHTML =
          '<div style="position:absolute;inset:0;background:#0B2B2B;display:flex;align-items:center;justify-content:center;color:#F6F5F3;font-family:Inter,sans-serif;font-size:1.0625rem;text-align:center;padding:2rem;font-weight:400;">' +
          msg +
          '</div>';
      });
    });
  }

  /* ===== FAQ one-open ===== */
  function initFaq() {
    var items = document.querySelectorAll('.sr-faq-item');
    items.forEach(function (item) {
      if (item.dataset.srFaqInit) return;
      item.dataset.srFaqInit = '1';
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (o) { if (o !== item) o.removeAttribute('open'); });
        }
      });
    });
  }

  /* ===== Booking calendar ===== */
  var DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var DAYS_SHORT = ['Mon','Tue','Wed','Thu','Fri','Sat'];
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function startOfWeek(date) {
    var d = new Date(date);
    var dow = d.getDay();
    var diff = dow === 0 ? -6 : 1 - dow;
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function initCalendar(root) {
    if (!root || root.dataset.srCalInit) return;
    root.dataset.srCalInit = '1';

    var calGrid = root.querySelector('[data-sr-cal-grid]');
    var calRange = root.querySelector('[data-sr-cal-range]');
    var calPrev = root.querySelector('[data-sr-cal-prev]');
    var calNext = root.querySelector('[data-sr-cal-next]');
    var selection = root.querySelector('[data-sr-booking-selection]');
    var selectionEmptyText = selection ? selection.dataset.emptyText || selection.innerHTML : '';
    var submitBtn = root.querySelector('[data-sr-booking-submit]');
    var form = root.querySelector('form.sr-booking-form');
    var confirm = root.querySelector('[data-sr-booking-confirm]');
    var card = root.querySelector('[data-sr-booking-card]');

    if (!calGrid || !calRange) return;

    var timesAttr = (root.dataset.times || '10:00,11:00,12:00,13:00,14:00,15:00').split(',').map(function(t){ return t.trim(); });
    var weeksAhead = parseInt(root.dataset.weeksAhead || '8', 10);

    var bookedSet = {};
    (root.dataset.bookedSlots || '').split(/[\n,]+/).forEach(function (line) {
      var key = line.trim();
      if (key) bookedSet[key] = true;
    });

    var weekOffset = 0;
    var selectedSlot = null;

    function render() {
      var today = new Date();
      var monday = startOfWeek(today);
      monday.setDate(monday.getDate() + weekOffset * 7);
      var weekDates = [];
      for (var i = 0; i < 6; i++) {
        var d = new Date(monday);
        d.setDate(monday.getDate() + i);
        weekDates.push(d);
      }
      var first = weekDates[0], last = weekDates[5];
      var label = first.getDate() + ' ' + MONTHS_SHORT[first.getMonth()] + ' — ' + last.getDate() + ' ' + MONTHS_SHORT[last.getMonth()] + ', ' + last.getFullYear();
      if (weekOffset === 0) label = 'This week · ' + label;
      else if (weekOffset === 1) label = 'Next week · ' + label;
      calRange.textContent = label;
      if (calPrev) calPrev.disabled = weekOffset <= 0;
      if (calNext) calNext.disabled = weekOffset >= weeksAhead;

      calGrid.innerHTML = '';
      var empty = document.createElement('div');
      empty.className = 'sr-cal-time';
      calGrid.appendChild(empty);

      weekDates.forEach(function (d, idx) {
        var isToday = d.toDateString() === today.toDateString();
        var isWeekend = idx === 5;
        var el = document.createElement('div');
        el.className = 'sr-cal-day' + (isToday ? ' is-today' : '') + (isWeekend ? ' is-weekend' : '');
        el.innerHTML = '<span class="sr-cal-day-name">' + DAYS_SHORT[idx] + '</span><span class="sr-cal-day-num">' + d.getDate() + '</span>';
        calGrid.appendChild(el);
      });

      timesAttr.forEach(function (time) {
        var t = document.createElement('div');
        t.className = 'sr-cal-time';
        t.textContent = time;
        calGrid.appendChild(t);

        weekDates.forEach(function (date, idx) {
          var iso = date.toISOString().slice(0, 10);
          var key = iso + '-' + time;
          var isPast = date < new Date(today.toDateString());
          var booked = isPast || bookedSet[iso + ' ' + time] === true || bookedSet[key] === true;

          var slot = document.createElement('button');
          slot.type = 'button';
          slot.className = 'sr-cal-slot';
          slot.dataset.key = key;
          slot.dataset.date = iso;
          slot.dataset.time = time;
          slot.dataset.readable = DAYS[idx] + ', ' + date.getDate() + ' ' + MONTHS[date.getMonth()];

          if (booked) {
            slot.classList.add('is-booked');
            slot.textContent = 'booked';
            slot.disabled = true;
          } else {
            slot.textContent = 'Reserve';
            slot.addEventListener('click', function () { selectSlot(slot); });
          }
          if (selectedSlot && slot.dataset.key === selectedSlot.key) {
            slot.classList.add('is-selected');
            slot.textContent = 'Selected';
          }
          calGrid.appendChild(slot);
        });
      });
    }

    function selectSlot(btn) {
      root.querySelectorAll('.sr-cal-slot.is-selected').forEach(function (s) {
        s.classList.remove('is-selected');
        s.textContent = 'Reserve';
      });
      btn.classList.add('is-selected');
      btn.textContent = 'Selected';
      selectedSlot = {
        key: btn.dataset.key,
        date: btn.dataset.date,
        time: btn.dataset.time,
        readable: btn.dataset.readable
      };
      if (selection) {
        selection.classList.remove('is-empty');
        var nextHr = String(parseInt(selectedSlot.time, 10) + 1).padStart(2, '0');
        selection.innerHTML =
          '<span class="sr-sel-date">' + selectedSlot.readable + '</span>' +
          '<span class="sr-sel-time">' + selectedSlot.time + ' — ' + nextHr + ':00 · Private hour</span>';
      }
      if (submitBtn) submitBtn.disabled = false;
      var hidden = root.querySelector('[data-sr-slot-hidden]');
      if (hidden) hidden.value = selectedSlot.readable + ' · ' + selectedSlot.time;
    }

    if (calPrev) calPrev.addEventListener('click', function () { if (weekOffset > 0) { weekOffset--; render(); } });
    if (calNext) calNext.addEventListener('click', function () { if (weekOffset < weeksAhead) { weekOffset++; render(); } });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!selectedSlot) { e.preventDefault(); return; }
      });
    }

    render();
  }

  function initBooking() {
    document.querySelectorAll('[data-sr-booking-root]').forEach(initCalendar);
  }

  function boot() {
    initReveal();
    initStickyCta();
    initVideo();
    initFaq();
    initBooking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
